import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import DBFViewer from './pages/DBFViewer';
import GoalPlanner from './pages/GoalPlanner';
import Home from './pages/Home';
import StatusImageCreator from './pages/StatusImageCreator';
import TextCalci from './pages/TextCalci';

export default function App(): React.JSX.Element {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/status" element={<StatusImageCreator />} />
        <Route path="/dbf" element={<DBFViewer />} />
        <Route path="/textcalci" element={<TextCalci />} />
        <Route path="/goalplanner" element={<GoalPlanner />} />
      </Routes>
    </Router>
  );
}
